import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import type { PrizeTableTooltip, TableRow, TableRowProps } from '../../../../../../types';
import { MobileCell } from '../MobileCell/MobileCell';

type MobileRowProps = ComponentProps<'div'> & {
  row: TableRow;
  headers: TableRowProps['headers'];
  rowIndex: number;
  tooltips?: PrizeTableTooltip;
};

function MobileRow({ className, row, headers, rowIndex, tooltips, ...props }: MobileRowProps) {
  const classes = {
    row: twMerge('p-4 flex flex-col gap-y-2', rowIndex % 2 === 0 ? 'bg-container-base' : 'bg-container', className),
  };
  return (
    <div className={classes.row} {...props}>
      {headers.map(({ value, label }) => (
        <MobileCell key={value} label={label} value={row[value]!} tooltip={tooltips?.get(value)} data-testid={`prize-table-mobile-row-${rowIndex}-${value}`} />
      ))}
    </div>
  );
}

export { MobileRow };
